import BaseProductService from "@/modules/core/product/protected/BaseProductService";
import env from "environment";

class MicroCreditProductService extends BaseProductService {
  constructor() {
    super({
      baseUrl: env.baseUrl + "/micro-credit/products"
    });
  }
}

const service = new MicroCreditProductService();

export default service;
